import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import VerticalStepper from "../../components/stepper";
import DirectorsRegistration from "./DirectorsRegistration";
import useDirectorsForm from "./useDirectorsForm";
import ConfirmAppointment from "./ConfirmAppointment";
import "./directors-form.scss";
import DeleteDialog from "../entities/key-personnel/DeleteDialog";
import { useDispatch, useSelector } from "react-redux";
import API_ROUTES from "../../api-routes";
import apiService from "../../services/service";
import {
  directorAppointment,
  updateDirectorAppointment,
  fetchDirectors,
} from "./directorsSlice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { resetRegData, setRegData } from "./directorsRegFormSlice";
import Layout from "../../Layout";
import ReactCountryFlag from "react-country-flag";
import { getName } from "country-list";
import { Button } from "primereact/button";

const DirectorsForm = ({ setShowDialog, countryCode, entityName }) => {
  const [btnToggle, setBtnToggle] = useState(true);
  const [isValidPosition, setIsValidPosition] = useState(false);
  const [formDetails, setFormDetails] = useState();
  const [formUpdate, setFormUpdate] = useState();
  const [isCongrats, setIsCongrats] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [validationMsg, setValidationMsg] = useState();
  const dispatch = useDispatch();
  const { id, entityid } = useParams();
  const positionsData = useSelector((state) => state.directorsRegForm.regData);
  const navigate = useNavigate();
  const [entity, setEntity] = useState({});
  const [errorIndex, setErrorIndex] = useState([]);

  const location = useLocation();
  const { rowData } = location.state || {};

  useEffect(() => {
    if (rowData) {
      setFormUpdate(rowData);
    }
  }, [rowData, setFormUpdate]);

  useEffect(() => {
    if (formUpdate) {
      const positionsArray = formUpdate.positions.slice(1);
      dispatch(
        setRegData({
          id: formUpdate.id || "",
          name: formUpdate.name || "",
          other_name: formUpdate.other_name || "",
          last_name: formUpdate.last_name || "",
          preferred_name: formUpdate.preferred_name || "",
          email: formUpdate.email || "",
          phone_code: formUpdate.phone_code || "",
          phone: formUpdate.phone || "",
          position: formUpdate.positions?.[0]?.position || "",
          start_date: formUpdate.positions?.[0]?.start_date
            ? formUpdate.positions[0].start_date
            : null,
          end_date: formUpdate.positions?.[0]?.end_date
            ? formUpdate.positions[0].end_date
            : null,
          status: formUpdate.positions?.[0]?.status || "",
          entityId: formUpdate.entity || "",
          positions: positionsArray,
          role: formUpdate.role || "",
          title: formUpdate.title || "",
        }),
      );
    }
  }, [formUpdate, dispatch]);

  const handleDirectorEdit = (directorData) => {
    setFormDetails(directorData);
    handleBack();
  };
  const regData = useSelector((state) => state.directorsRegForm.regData || {});

  const handleCheckError = () => {
    const combinedData = [
      {
        end_date: regData.end_date,
        position: regData.position,
        start_date: regData.start_date,
        status: regData.status,
      },
      ...regData.positions,
    ];

    let isValid = true;
    let invalidIndices = [];
    let validationMessages = {};

    for (let x = 0; x < combinedData.length; x++) {
      for (let y = x + 1; y < combinedData.length; y++) {
        if (combinedData[x].position === combinedData[y].position) {
          const startX = combinedData[x].start_date
            ? new Date(combinedData[x].start_date).getTime()
            : null;
          const endX = combinedData[x].end_date
            ? new Date(combinedData[x].end_date).getTime()
            : null;
          const startY = combinedData[y].start_date
            ? new Date(combinedData[y].start_date).getTime()
            : null;
          const endY = combinedData[y].end_date
            ? new Date(combinedData[y].end_date).getTime()
            : null;

          if ((!startX && !endX) || (!startY && !endY)) {
            continue;
          }
          if (!endX && startX && !endY && startY) {
            if (startX === startY) {
              isValid = false;
              invalidIndices.push(y);
              Object.assign(validationMessages, {
                [y]: "Error: This position has been added before!",
              });
            }
            continue;
          }

          if (startX === startY && endX === endY) {
            isValid = false;
            invalidIndices.push(y);
            Object.assign(validationMessages, {
              [y]: "Error: This position has been added before within the same period of dates!",
            });
            continue;
          }

          if (startX === startY && endX !== endY) {
            isValid = false;
            invalidIndices.push(y);
            Object.assign(validationMessages, {
              [y]: "Error: This position has been added before!",
            });
            continue;
          }
        }
      }
    }

    if (!isValid) {
      setValidationMsg(validationMessages);
      setErrorIndex(invalidIndices);
      setIsValidPosition(true);
    } else {
      setValidationMsg([]);
      setIsValidPosition(false);
    }
  };

  useEffect(() => {
    handleCheckError();
  }, [regData]);

  const steps = [
    {
      label: "Appointment Details",
      content: (
        <DirectorsRegistration
          btnToggle={btnToggle}
          setBtnToggle={setBtnToggle}
          formDetails={formDetails}
          setFormDetails={setFormDetails}
          formUpdate={formUpdate}
          setFormUpdate={setFormUpdate}
          validationMsg={validationMsg}
          errorIndex={errorIndex}
        />
      ),
    },
    {
      label: formUpdate ? "Confirm Updates" : "Confirm Appointment",
      content: (
        <ConfirmAppointment
          isCongrats={isCongrats}
          onEdit={handleDirectorEdit}
          formUpdate={formUpdate}
        />
      ),
    },
  ];

  const {
    handleBack,
    handleNext,
    activeIndex,
    cancelAppointment,
    setCancelAppointment,
    showDeleteModal,
    editMessage,
    setEditMessage,
  } = useDirectorsForm(steps);

  const handleCancel = () => {
    showDeleteModal();
  };

  const handleAppointmentSubmit = async () => {
    setIsLoading(true);
    if (regData) {
      const directorData = {
        name: regData?.name || "",
        other_name: regData?.other_name || "",
        last_name: regData?.last_name || "",
        preferred_name: regData?.preferred_name || "",
        email: regData?.email || "",
        phone: regData?.phone || null,
        phone_code: regData?.phone_code || null,
        positions: [
          {
            position: regData?.position || "",
            start_date: regData?.start_date || null,
            end_date: regData?.end_date || null,
            status: regData?.status || "",
          },
        ],
        role: regData?.role,
        title: regData?.title,
      };

      const apiRoute = API_ROUTES.ADD_DIRECTOR;

      try {
        const res = await apiService(apiRoute, "POST", {
          body: JSON.stringify(directorData),
          replace: { id: entityid },
        });
        if (res.status) {
          dispatch(directorAppointment(res.data));
          dispatch(resetRegData(res.data));
          // GXM-1767: Refetch directors list with skipCache to bypass APIM cache
          dispatch(fetchDirectors({ id: entityid, skipCache: true }));
        } else {
          console.log("Not getting response");
        }
        setIsLoading(false);
      } catch (error) {
        console.error(error);
        setIsLoading(false);
      }
      setIsCongrats(true);
    }
  };

  const entityId = regData?.entityId;
  const fetchEntity = async () => {
    const { data } = await apiService(API_ROUTES.FETCH_ENTITY, "GET", {
      replace: { id: entityid },
    });
    setEntity(data);
  };

  useEffect(() => {
    if (entityid) {
      fetchEntity();
    }
  }, []);

  // useEffect(() => {
  //   if (editMessage && entityId) {
  //     navigate(`/entity/${entityId}/directors`, {
  //       state: { editMessage: editMessage },
  //     });
  //     dispatch(resetRegData());
  //   }
  // }, [editMessage, navigate, entityId]);

  useEffect(() => {
    dispatch(resetRegData());
  }, [navigate]);

  const handleAppointmentUpdate = async () => {
    setIsLoading(true);
    setShowDialog(false);
    if (regData) {
      const directorUpdatedData = {
        id: regData.id || "",
        name: regData?.name || "",
        other_name: regData?.other_name || "",
        last_name: regData?.last_name || "",
        preferred_name: regData?.preferred_name || "",
        email: regData?.email || "",
        phone: regData?.phone || null,
        phone_code: regData?.phone_code || null,
        positions: [
          {
            position: regData?.position || "",
            start_date: regData?.start_date || null,
            end_date: regData?.end_date || null,
            status: regData?.status || "",
          },
          ...positionsData.positions,
        ],
        role: regData?.role,
        title: regData?.title,
      };
      const apiRoute = API_ROUTES.UPDATE_DIRECTOR;
      try {
        const res = await apiService(apiRoute, "PUT", {
          body: JSON.stringify(directorUpdatedData),
          replace: { id: directorUpdatedData.id },
        });
        if (res.status) {
          dispatch(
            updateDirectorAppointment({
              id: directorUpdatedData.id,
              data: directorUpdatedData,
            }),
          );
          const name =
            regData?.preferred_name ||
            [regData.name, regData.other_name, regData.last_name]
              .filter(Boolean)
              .join(" ");
          if (entityId) {
            navigate(`/entity/${entityId}/directors`, {
              state: {
                editMessage: `Changes on ${name} appointments have been updated.`,
              },
            });
            dispatch(resetRegData());
          }
        } else {
          console.log("Not getting response");
        }
        setIsLoading(false);
      } catch (error) {
        console.error(error);
        setIsLoading(false);
      }
    }
  };

  const handleDialogToggle = () => {
    if (regData) {
      const hasValue = Object.values(regData).some(
        (value) => value != "" && value != false && value != [],
      );
      setShowDialog(hasValue);
    }
  };

  useEffect(() => {
    handleDialogToggle();
  }, [regData]);

  return (
    <Layout
      crumbs={[
        {
          label: (
            <span style={{ textDecoration: "underline", cursor: "pointer" }}>
              My Entities
            </span>
          ),
          command: () => navigate("/entities"),
          id: "entities",
        },
        {
          label: (
            <span style={{ textDecoration: "underline", cursor: "pointer" }}>
              {entityName ? entityName : entity?.name} (
              <ReactCountryFlag
                countryCode={countryCode ? countryCode : entity?.country}
                svg
                className=""
              />{" "}
              {getName(countryCode ? countryCode : entity?.country || "")})
            </span>
          ),
          id: "entity",
          command: () => navigate(`/entity/${entityid}/dashboard`),
        },
        {
          label: (
            <span style={{ textDecoration: "underline", cursor: "pointer" }}>
              Directors & Shareholders
            </span>
          ),
          command: () => navigate(-1),
          id: "core-entity-data",
        },
        ...((formUpdate && [
          { label: `${regData.name} ${regData.last_name}` },
        ]) ||
          []),
        {
          label: formUpdate ? "Edit Director" : "Add New Director",
          id: "add-new-director",
        },
      ]}
    >
      <div className="grid director-form">
        <div className="lg:col-3 md:col-12 sm:col-12 xs:col-12 pt-4">
          <Card className="card-onboard">
            {formUpdate ? (
              <>
                <p className="add-new-entity-heading">Edit Director</p>
                <p className="input-label m-0">
                  Edit and confirm all the necessary adjustments for this
                  director.
                </p>
              </>
            ) : (
              <>
                <p className="add-new-entity-heading">Add New Director</p>
                <p className="input-label m-0">
                  Complete the necessary steps to appoint a new director to this
                  company.
                </p>
              </>
            )}
            <Divider />
            <div className="step-menu">
              <VerticalStepper options={steps} activeIndex={activeIndex} />
            </div>
          </Card>
        </div>
        <div className="lg:col-9 md:col-12 sm:col-12 xs:col-12 pt-4">
          <Card className="card-onboard">{steps[activeIndex].content}</Card>
          {!isCongrats ? (
            <div className="next-btn-footer">
              {activeIndex !== 0 ? (
                <>
                  <div className="d-flex justify-content-start">
                    <button
                      type="button"
                      className="generic-cancel"
                      onClick={() => {
                        navigate(-1);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </>
              ) : null}
              {activeIndex === 0 ? <div></div> : <div></div>}
              <div className="flex justify-content-end gap-2">
                {activeIndex === 0 ? (
                  <button
                    type="button"
                    className="cancel-btns"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    Cancel
                  </button>
                ) : null}
                {activeIndex === 0 ? (
                  ""
                ) : (
                  <button
                    type="button"
                    onClick={handleBack}
                    disabled={activeIndex === 0}
                    className="cancel-btns"
                  >
                    Back
                  </button>
                )}
                {activeIndex === steps.length - 1 ? (
                  formUpdate ? (
                    <Button
                      type="submit"
                      className="add-new-contact confirm-updates"
                      onClick={handleAppointmentUpdate}
                      loading={isLoading}
                    >
                      {!isLoading && "Confirm Updates"}
                    </Button>
                  ) : (
                    <Button
                      type="submit"
                      className="add-new-contact confirm-appointment"
                      onClick={handleAppointmentSubmit}
                      loading={isLoading}
                    >
                      {!isLoading && "Confirm Appointment"}
                    </Button>
                  )
                ) : (
                  <button
                    disabled={
                      btnToggle === true || isValidPosition === true
                        ? true
                        : false
                    }
                    className={`add-new-contact ${btnToggle === true || isValidPosition === true ? "disable" : null}`}
                    type="button"
                    onClick={handleNext}
                  >
                    Next
                  </button>
                )}
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <DeleteDialog
        visible={cancelAppointment}
        onHide={() => setCancelAppointment(false)}
        cancelAppointment={cancelAppointment}
        entityId={entityId}
      />
    </Layout>
  );
};

export default DirectorsForm;
